import { useSelector, useDispatch } from 'react-redux';
import { CartoLayer } from '@deck.gl/carto';
import { selectSourceById, updateLayer } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const BROWARDBUSROUTE_LAYER_ID = 'browardBusRouteLayer';

export const CATEGORY_COLORS = {
  'Bus Route': [126, 87, 194],
};

const layerConfig = {
  title: 'Bus routes',
};

function BrowardBusRouteLayer() {
  const dispatch = useDispatch();
  const { browardBusRouteLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) =>
    selectSourceById(state, browardBusRouteLayer?.source)
  );
  const cartoLayerProps = useCartoLayerProps({ source });

  if (browardBusRouteLayer && source) {
    return new CartoLayer({
      ...cartoLayerProps,
      id: BROWARDBUSROUTE_LAYER_ID,

      stroked: false,
      pointRadiusUnits: 'pixels',
      lineWidthUnits: 'pixels',
      pickable: true,
      visible: browardBusRouteLayer.visible,
      opacity: browardBusRouteLayer.opacity,

      getLineColor: [126, 87, 194],
      lineWidthMinPixels: 2,

      onDataLoad: (data) => {
        dispatch(
          updateLayer({
            id: BROWARDBUSROUTE_LAYER_ID,
            layerAttributes: { ...layerConfig },
          })
        );
        cartoLayerProps.onDataLoad && cartoLayerProps.onDataLoad(data);
      },

      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature({
              feature: info.object,
              title: 'Bus Route Details',
              includeColumns: ['Route_Name', 'Route_Description'],
            }),
          };
        }
      },
    });
  }
}

export default BrowardBusRouteLayer;
